import { Component, OnInit } from '@angular/core';
import {FilterService} from '../../filters/service/filter.service';
import {ActivatedRoute, Router} from '@angular/router';
import {AlgorithmConfigService} from '../service/algorithm-config.service';
import {FormControl} from '@angular/forms';

@Component({
  selector: 'app-algorithm-config-view',
  templateUrl: './algorithm-config-view.component.html',
  styleUrls: ['./algorithm-config-view.component.css']
})
export class AlgorithmConfigViewComponent implements OnInit {
  currentUser: any;
  currentUserPermission: any = [];
  SYSTEM_ALGORITHM_CONFIG: boolean;
  public algorithmList: any = [];
  public campaignAlgorithmList: any = [];
  public userCampaignList: any = [];
  public algorithmMap = {};
  public campaignList: any = [];
         campaignId: any;
         campaignNumber: any;
    searchTerm: FormControl = new FormControl();

    public loading = true;
    public showCampaignSelect = false;
    public campaignAlgoFlag = false;
  constructor(private algorithmConfigService: AlgorithmConfigService,
              private router: Router,
              private _route: ActivatedRoute) {
      this._route.queryParams.subscribe(params => {
          this.campaignId = params['campaignId'] || '';
          this.campaignNumber = params['campaignNumber'] || '';
      });
      this.showCampaignSelect = false;
      if (this.campaignId !== '' && this.campaignId !== undefined) {
            this.showCampaignSelect = true;
          this.getCampaign(this.campaignId);
      }

      console.log(this.campaignId);
      console.log(this.campaignNumber);
  }

  ngOnInit() {
    this.getAllSystemAlgorithm();
      this.searchTerm.valueChanges.subscribe(
          term => {
              if (term !== '') {
                  this.algorithmConfigService.search(term, 0, 999).subscribe(
                      data => {
                          const response = data.json();
                          this.campaignList = response.campaigns;
                      });
              }
          });

      this.currentUser = JSON.parse(localStorage.getItem('user'));
     /* this.currentUserPermission = this.currentUser.permissions[localStorage.getItem('clientId')];
      for (let i = 0; i < this.currentUserPermission.length; i++) {
          if (this.currentUserPermission[i] === 'SYSTEM_ALGORITHM_CONFIG') {
              console.log('Enable ORDER_PROVISION Permission');
              this.SYSTEM_ALGORITHM_CONFIG = true;
              break;
          }
      }*/
  }

  public getAllSystemAlgorithm() {
    this.algorithmConfigService.getAllSystemAlgorithm()
        .subscribe(data => {
          const response: any = data.json();
          this.algorithmList = response;
          this.loading = false;
        }, (error) => {
          this.loading = false;
          // this.toastr.error('', 'Please try again');
        });
  }

  editThreshold(algo) {
    console.log(algo);
    this.router.navigate( [ '/elasticcare/add/algorithm' ], { fragment: algo.id } );
  }

    getCampaign(event) {
        console.log(event);
        this.algorithmConfigService.getAllCampaignAlgorithm(event)
            .subscribe(data => {
                const response: any = data.json();
                this.campaignAlgorithmList = response;
                console.log(this.campaignAlgorithmList);
                this.campaignAlgoFlag = this.campaignAlgorithmList.length > 0 ? true : false;
                this.loading = false;
            }, (error) => {
                this.loading = false;
                // this.toastr.error('', 'Please try again');
            });
    }

}
